import { render, staticRenderFns } from "./Prizes.vue?vue&type=template&id=d4ee4cd2"
import script from "./Prizes.js?vue&type=script&lang=js&external"
export * from "./Prizes.js?vue&type=script&lang=js&external"
import style0 from "./Prizes.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports